import { Schema } from 'rsuite';
import { MultiLingual } from '@/models/language.model';

/**
 * Form rule for a MultiLingual field: every language's text is at most [max] characters, and a
 * [required] field needs text in at least one language.
 */
export const multiLingualRule = (max: number, required = false) =>
  Schema.Types.ObjectType<MultiLingual>().addRule(
    (value?: MultiLingual) => {
      const texts = Object.values(value ?? {}).filter(t => t && t.trim());
      return (!required || texts.length > 0) && texts.every(t => t!.length <= max);
    },
    required ? `Enter it in at least one language, up to ${max} characters each.` : `Up to ${max} characters per language.`,
    true,
  );
